import {ErrorBoundary} from 'react-error-boundary'
import {IconAlertCircle} from '@tabler/icons'
import type {ReactElement} from 'react'
import WebInternalAppAuthProvider from '../auth/WebInternalAuthProvider'
import WebInternalAppHeader from './WebInternalAppHeader'
import WebInternalAppNavbar from './WebInternalAppNavbar'

import errorSummary from '../../core/errorSummary'
import {webInternalApps} from './webInternalApps'

import {Alert, AppShell, Code, MantineProvider, Skeleton} from '@mantine/core'
import {BrowserRouter, Route, Routes} from 'react-router-dom'
import React, {Suspense} from 'react'

interface ErrorFallbackProps {
  error: Error
}

export default function WebInternalAppRoot(): ReactElement {
  const routes = webInternalApps.map(app => (
    <Route
      key={app.name}
      element={app.element}
      path={app.routeNested ? app.routePath + '/*' : app.routePath}
    />
  ))
  return (
    <MantineProvider
      theme={{colorScheme: 'dark'}}
      withGlobalStyles
      withNormalizeCSS
    >
      <WebInternalAppAuthProvider>
        <BrowserRouter>
          <AppShell
            header={<WebInternalAppHeader />}
            navbar={<WebInternalAppNavbar />}
            padding='sm'
          >
            <ErrorBoundary FallbackComponent={ErrorFallback}>
              <Suspense fallback={<Skeleton height='200px' width='100%' />}>
                <Routes>{routes}</Routes>
              </Suspense>
            </ErrorBoundary>
          </AppShell>
        </BrowserRouter>
      </WebInternalAppAuthProvider>
    </MantineProvider>
  )
}

function ErrorFallback({error}: ErrorFallbackProps): ReactElement {
  return (
    <Alert color='red' icon={<IconAlertCircle />} title='Error'>
      <Code block>{errorSummary(error)}</Code>
    </Alert>
  )
}
